import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getMeshNodes } from '../api';

export const meshKeys = {
  nodes: ['tailscale', 'nodes'] as const,
};

// staleTime matches the backend's 30s Headscale cache. The endpoint is
// full-admin and ATEK-internal-staff only.
export function useMeshNodes(enabled = true) {
  return useQuery({
    queryKey: meshKeys.nodes,
    queryFn: () => getMeshNodes(),
    enabled,
    staleTime: 30 * 1000,
    retry: 1,
  });
}

/**
 * User-requested reload: asks the backend to skip its caches, which a plain
 * refetch would not. A failure lands in the query's error state for the page.
 */
export function useRefreshMeshNodes() {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient
      .fetchQuery({ queryKey: meshKeys.nodes, queryFn: () => getMeshNodes(true), staleTime: 0 })
      .catch(() => undefined);
  }, [queryClient]);
}
